export const REFETCH_CREDIT_USAGE_INTERVAL = 5 * 60 * 1_000; // 5 minutes
